"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var Div = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  margin-top: ", ";\n  ", ";\n\n  .c-axs-button {\n    ", ";\n    ", ";\n\n    @media (min-width: 768px) {\n      margin-right: 0;\n    }\n  }\n\n  .c-axs-button + .c-axs-button {\n      ", ";\n  }\n\n  @media (max-width: 750px) {\n    .c-axs-button {\n      width: 100%;\n    }\n  }\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  margin-top: ", ";\n  ", ";\n\n  .c-axs-button {\n    ", ";\n    ", ";\n\n    @media (min-width: 768px) {\n      margin-right: 0;\n    }\n  }\n\n  .c-axs-button + .c-axs-button {\n      ", ";\n  }\n\n  @media (max-width: 750px) {\n    .c-axs-button {\n      width: 100%;\n    }\n  }\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n"])), function (_a) {
    var reverse = _a.reverse;
    return (reverse ? 'row-reverse' : 'row');
}, function (_a) {
    var center = _a.center;
    return (center ? 'center' : 'flex-start');
}, function (_a) {
    var margin = _a.margin;
    return margin ? '48px' : '';
}, function (_a) {
    var stacked = _a.stacked;
    return stacked && 'flex-wrap: wrap-reverse';
}, function (_a) {
    var reverse = _a.reverse, stacked = _a.stacked;
    return reverse && 'margin-left: 16px';
}, function (_a) {
    var stacked = _a.stacked;
    return stacked && 'width: 100%';
}, function (_a) {
    var stacked = _a.stacked;
    return stacked ? 'margin-left: 0' : 'margin-left: 16px';
});
var AXSFormActions = function (props) {
    return (React.createElement(Div, __assign({}, props, { className: classnames_1.default(['c-axs-form-actions', props.className]) })));
};
AXSFormActions.defaultProps = {
    reverse: false,
};
exports.default = AXSFormActions;
var templateObject_1;
//# sourceMappingURL=AXSFormActions.js.map